import { Pipe, PipeTransform } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, catchError, shareReplay } from 'rxjs/operators';
import { UserService } from '../../services/user/user.service';

@Pipe({
  name: 'userName'
})
export class UserNamePipe implements PipeTransform {
  private cache = new Map<string, Observable<string>>();

  constructor(private userService: UserService) {}

  transform(userId: string): Observable<string> {
    if (!userId) {
      return of('');
    }
    
    const cleanId = userId.trim();
    if (this.cache.has(cleanId)) {
      return this.cache.get(cleanId)!;
    }

    const req$ = this.userService.getaccountinfobyid(cleanId).pipe(
      map((res: any) => {
        try {
          let data = Array.isArray(res) ? res[0] : res;
          if (data && (data.nom || data.prenom)) {
            return `${data.nom || ''} ${data.prenom || ''}`.trim() || cleanId;
          }
          if (data && data.username) {
            return data.username;
          }
          if (data && data.personnel) {
            let p = Array.isArray(data.personnel) ? data.personnel[0] : data.personnel;
            if (p && (p.nom || p.prenom)) {
              return `${p.nom || ''} ${p.prenom || ''}`.trim() || cleanId;
            }
          }
        } catch (e) {
          console.error('UserNamePipe parse error', e);
        }
        return cleanId;
      }),
      catchError((err) => {
        console.error('UserNamePipe HTTP error for', cleanId, err);
        return of(cleanId);
      }),
      shareReplay(1)
    );

    this.cache.set(cleanId, req$);
    return req$;
  }
}
